import React from 'react';
import type { DocumentModalProps } from '../achievements.types';

// * [COMPONENT] Shared modal for viewing certificates and marksheets
// ? Reuses the same visual pattern as the original CertificateModal
export const DocumentModal: React.FC<DocumentModalProps> = ({ modal, onClose }) => {
  React.useEffect(() => {
    if (!modal.isOpen) return;
    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modal.isOpen, onClose]);

  if (!modal.isOpen) return null;

  return (
    <div className="cert-modal-overlay" onClick={onClose}>
      <div className="cert-modal-dialog" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="cert-modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>

        <h3 className="cert-modal-title">{modal.title}</h3>

        <div className="cert-modal-meta">
          {modal.subtitle}
        </div>

        {modal.imageSrc && (
          <img
            src={modal.imageSrc}
            alt={`${modal.title}`}
            className="cert-modal-image"
          />
        )}
      </div>
    </div>
  );
};

export default DocumentModal;
